import { Horizontal, Texto } from '@gravitate-js/excalibrr'
import { Spin, theme } from 'antd'
import { useEffect, useState } from 'react'

export type WorkingIndicatorProps = {
  // The live streamed snapshot for the thread being shown. Passed in (rather than
  // read from the global store) so this only ever reflects the active thread — see
  // MessageList's `streamActive` gating.
  streamingText?: string
}

// Shows the agent's live token stream as it arrives (real progress feedback),
// wrapped in a spinner + elapsed-timer chrome so it's clearly "working, not stuck"
// even before the first token. The streamed text is a raw preview; the canonical
// formatted reply replaces this once the turn completes.
export function WorkingIndicator({
  streamingText = '',
}: WorkingIndicatorProps) {
  const { token } = theme.useToken()
  const [elapsed, setElapsed] = useState(0)

  useEffect(() => {
    const start = Date.now()
    const timer = setInterval(
      () => setElapsed(Math.floor((Date.now() - start) / 1000)),
      1000,
    )
    return () => clearInterval(timer)
  }, [])

  return (
    <Horizontal
      gap={8}
      verticalCenter
      style={{
        alignSelf: 'flex-start',
        maxWidth: '85%',
        background: token.colorInfoBg,
        padding: '10px 14px',
        borderRadius: 10,
      }}
    >
      <Spin size='small' />
      <Texto
        appearance={streamingText ? undefined : 'hint'}
        style={{ whiteSpace: 'pre-wrap' }}
      >
        {streamingText || 'Working'}
        {elapsed >= 1 ? ` · ${elapsed}s` : ''}
      </Texto>
    </Horizontal>
  )
}
